import { useEffect, useRef, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ComposePageScreen } from "./screens/composePage";
import { useQuery } from "@apollo/client";
import {
  getMenuSectionListQuery,
} from "./graphql/queries/getMenuList";
import { NotFoundContainer } from "./components/not-found-page/NotFoundContainer";
import { IEBanner } from "./components/ieBanner";
import { Header } from "./components/header";
import { Footer } from "./components/footer";
import { BACKEND_ENDPOINT, tags } from "./config";
import { LeadManager } from "./components/composePage/leads-nurture/LeadManager";
import { SalesforceChatNew } from "./components/chatNew";
import { useAuth0 } from "@auth0/auth0-react";
import StaticLogoutPage from "./components/StaticLogoutPage";
export type MenuItemsType = {
  slug: string;
  text: string;
};
let Body = () => {
  const { data: menuSectionList } = useQuery<any>(getMenuSectionListQuery, {
    variables: {
      usePreview: false,
      tags: tags?.globalSubMenu,
    },
    fetchPolicy: "cache-and-network",
  });

  interface composePageSubMenuDataProps {
    name: string;
    itemUrl: string;
  }

  const composePageSubMenuData: composePageSubMenuDataProps[] =
    menuSectionList?.MenuList?.[0]?.menuSections;

  const composePageSubMenu = (composePageSubMenuData ?? []).map(
    ({ name, itemUrl }) => ({
      slug: itemUrl,
      text: name,
    })
  );

  const { pathname } = useLocation();
  const isSitemap = pathname === '/sitemap'
  const slug = pathname.replace("/", "");

  const isComposePageMenu =
    composePageSubMenu?.length > 0 &&
    (composePageSubMenu ?? []).some((m) => m.slug === slug)!;

    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
  return (
    <div className="flex flex-col mx-auto lg:max-w-[1280px] md:max-w-[960px] max-tab:max-w-[600px] mb-4" style={{display:isMobile?"block":"",}}>
      <div className="flex-1" >
        <div>
          <Routes>
            <Route path="/logout" key="logout" element={<StaticLogoutPage />} />

            {(isComposePageMenu) ? (
              (composePageSubMenu ?? []).map(({ slug }) => (
                <Route
                  key={slug!}
                  path={`/${slug}`}
                  element={
                    <ComposePageScreen
                      menus={composePageSubMenu as MenuItemsType[]}
                    />
                  }
                />
              ))
            ) : slug !== "notfound" && slug !== "" && !isSitemap ? (
              <Route
                key={slug!}
                path={`/${slug}`}
                element={
                  <ComposePageScreen
                    menus={[{ slug, text: slug }] as MenuItemsType[]}
                  />
                }
              />
            ) : isSitemap ? (
              <Route
                key={pathname!}
                path={pathname}
                element={
                  <ComposePageScreen
                    menus={[{ slug, text: slug }] as MenuItemsType[]}
                  />
                }
              />
            ):(
              <Route
                path="*"
                key="notfound"
                element={<NotFoundContainer redirectURL="/" label="Go Home" />}
              />
            )}
          </Routes>
        </div>
      </div>
    </div>
  );
};
const App = () => {

  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
  const hasAttemptedSilentAuthRef = useRef(false);

  useEffect(() => {
    if (isLoading || isAuthenticated || hasAttemptedSilentAuthRef.current) {
      return;
    }

    hasAttemptedSilentAuthRef.current = true;

    // Pick up an existing shared SSO session so header auth state is correct after landing from My Account.
    void getAccessTokenSilently().catch(() => {
      // No active SSO session for this SPA, leave the user as logged out.
    });
  }, [getAccessTokenSilently, isAuthenticated, isLoading]);

  return (
    <div className="App ">
      <Header />
      <IEBanner>
        <Body />
      </IEBanner>
      {BACKEND_ENDPOINT && <LeadManager apiEndpoint={BACKEND_ENDPOINT}/>}
      <SalesforceChatNew/>
      <Footer />
    </div>
  );
};

export default App;
